/**
 * Pick a string from API multilingual JSONB fields ({ en: "...", ar: "..." }).
 */
export function pickLocalized(value, lang = "en") {
  if (value == null) return "";
  if (typeof value === "string") return value;
  if (typeof value === "object") {
    return (
      value[lang] ||
      value.en ||
      Object.values(value).find((v) => typeof v === "string" && v.trim()) ||
      ""
    );
  }
  return String(value);
}
